import { Component, ChangeDetectionStrategy, Inject } from '@angular/core';
import { ButtonTypeEnum } from '@panaya/ui/p-button';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface DialogData {
    isValidEntity: boolean;
}

export enum UnsavedChangesResult {
    DISCARD,
    SAVE,
    STAY
}

@Component({
    selector: 'p-pending-changes-dialog',
    template: `
        <p-dialog-container>
            <p-dialog-header title="{{ 'Execution.dirtyEntity.header' | translate }}"></p-dialog-header>
            <div class="p-dialog-content">
                <p>{{ 'Execution.dirtyEntity.body' | translate }}</p>
                <p *ngIf="!data.isValidEntity">{{ 'Execution.dirtyEntity.extra_msg' | translate }}</p>
            </div>
            <p-dialog-footer [btnConfig]="footerConfig"></p-dialog-footer>
        </p-dialog-container>
    `,
    styleUrls: ['./p-pending-changes-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PPendingChangesDialogComponent {
    buttonType = ButtonTypeEnum;
    unsavedChangesResult = UnsavedChangesResult;

    constructor(public dialogRef: MatDialogRef<boolean>, @Inject(MAT_DIALOG_DATA) public data: DialogData) {}

    close(result) {
        this.dialogRef.close(result);
    }

    get footerConfig() {
        return [
            {
                text: 'Execution.dirtyEntity.save',
                click: () => this.close(UnsavedChangesResult.SAVE),
                disabled: !this.data.isValidEntity
            },
            {
                text: 'Execution.dirtyEntity.discard',
                click: () => this.close(UnsavedChangesResult.DISCARD)
            },
            {
                text: 'Execution.dirtyEntity.stay_on_page',
                click: () => this.close(UnsavedChangesResult.STAY)
            }
        ];
    }
}
